import { Pressable, View } from 'react-native'

import { styled } from '~/core/styled'

export const Root = styled(View, {
  base: {
    width: '100%',
  },
})

export const ClearButtonTouchableArea = styled(Pressable, theme => {
  return {
    base: {
      position: 'absolute',
    },
    variants: {
      size: {
        md: {
          width: theme.sizingMedium,
          height: theme.sizingMedium,
        },
        ml: {
          width: theme.sizingMediumlarge,
          height: theme.sizingMediumlarge,
        },
        lg: {
          width: theme.sizingLarge,
          height: theme.sizingLarge,
        },
        xl: {
          width: theme.sizingExtralarge,
          height: theme.sizingExtralarge,
        },
      },
    },
  }
})
